module.exports = __webpack_public_path__ + "static/media/traveloka.19720bb6.png";